import { render } from "./ConfigGameInstanceMobile.vue?vue&type=template&id=48e6daaa&scoped=true"
import script from "./ConfigGameInstanceMobile.vue?vue&type=script&lang=js"
export * from "./ConfigGameInstanceMobile.vue?vue&type=script&lang=js"

import "./ConfigGameInstanceMobile.vue?vue&type=style&index=0&id=48e6daaa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48e6daaa"]])

export default __exports__